// extracted by mini-css-extract-plugin
export default {"container":"bnuVyC0lOUPw_0Bixt4I","size-std":"lAj8SZ3rWah_vHOOX_hw","size-sm":"nGp84Rvo6TqxnjTV9XkE","size-xs":"Fs8uhL7Pqz1tdbQn5ge2"};